var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// libs
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// includes
import { getPermissionsApi } from '@/includes/api/account/permissions';
import { getAccountApi } from '@/includes/api/account/get';
// constants
import Routes from '@/constants/Routes';
import { NULL } from '@/constants/Misc';
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import { IconCicularLoader } from '@/constants/icons/svg';
// stores
import useCampaignDetailsStore from '@/stores/CampaignDetails';
import useDashboardStore from '@/stores/Dashboard';
import useReadCampaignStore from '@/stores/ReadCampaign';
import useSuggestedKeywordsStore from '@/stores/SuggestedKeywords';
import useWriteCampaignStore from '@/stores/WriteCampaign';
import useAccountStore from '@/stores/account';
// styles
import styles from './AccountBootstrap.module.scss';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
const AccountBootstrap = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const navigate = useNavigate();
    const { loggedInAccountDetails, setLoggedInAccountDetails, getCurrentAccountId, clearLoggedInAccountDetails, } = useAccountStore((state) => ({
        user: state.user,
        loggedInAccountDetails: state.loggedInAccountDetails,
        setLoggedInAccountDetails: state.setLoggedInAccountDetails,
        getCurrentAccountId: state.getCurrentAccountId,
        accounts: state.accounts,
        setAccounts: state.setAccounts,
        clearLoggedInAccountDetails: state.clearLoggedInAccountDetails,
    }));
    const clearCampaignDetails = useCampaignDetailsStore((state) => state.clear);
    const clearHomeDetails = useDashboardStore((state) => state.clear);
    const clearReadCampaignDetails = useReadCampaignStore((state) => state.clear);
    const clearWriteCampaignDetails = useWriteCampaignStore((state) => state.clear);
    const clearSuggestedKeywordDetails = useSuggestedKeywordsStore((state) => state.clearKeywords);
    const prevLoggedInAccountDetails = useRef(undefined);
    useEffect(() => {
        initiateAccountLogin();
    }, []);
    useEffect(() => {
        var _a, _b;
        if (((_a = prevLoggedInAccountDetails.current) === null || _a === void 0 ? void 0 : _a.accountId) ===
            ((_b = loggedInAccountDetails.account) === null || _b === void 0 ? void 0 : _b.accountId)) {
            return;
        }
        // TODO: check these later, currently facing a bug because of this
        // clearCampaignDetails();
        // clearReadCampaignDetails();
        // clearWriteCampaignDetails();
        clearHomeDetails();
        clearSuggestedKeywordDetails();
    }, [loggedInAccountDetails.account]);
    const initiateAccountLogin = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setLoading(true);
            const accountId = yield getCurrentAccountId();
            if (!accountId || accountId === NULL) {
                // check if user is admin and redirect to account selection screen
                const { permissions, isAdmin } = yield getPermissionsApi({});
                setLoggedInAccountDetails(Object.assign(Object.assign({}, loggedInAccountDetails), { isAdmin,
                    permissions }));
                navigate(Routes.ACCOUNT_SELECT, { preventScrollReset: true });
            }
            else {
                const permissionPromise = getPermissionsApi({ accountId });
                const accountPromise = getAccountApi({ accountId });
                const [permissionResult, accountResult] = yield Promise.all([
                    permissionPromise,
                    accountPromise,
                ]);
                const { permissions, isAdmin } = permissionResult;
                const { account } = accountResult;
                if (!account) {
                    clearLoggedInAccountDetails();
                    navigate(Routes.ACCOUNT_SELECT, {
                        preventScrollReset: true,
                    });
                }
                else {
                    setLoggedInAccountDetails({
                        account,
                        isAdmin,
                        permissions,
                    });
                }
            }
        }
        catch (error) {
            setError(true);
        }
        finally {
            setLoading(false);
        }
    });
    return (React.createElement("div", { className: styles.container },
        loading && !error && (React.createElement("div", { className: styles.containerCenter },
            React.createElement(IconCicularLoader, { height: 108, width: 108, className: styles.loader }),
            React.createElement(Text, { variant: DlsFontVariants.subheader_S1_Reg, color: DlsColorTokens.text_Med_Emphasis }, "Loading Account Details..."))),
        !loading && error && (React.createElement("div", { className: styles.containerCenter },
            React.createElement(Text, { variant: DlsFontVariants.subheader_S1_Bold, color: DlsColorTokens.text_Med_Emphasis }, "Something went wrong!"))),
        !loading && !error && children));
};
export default AccountBootstrap;
